var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Icon } from '@citrus/icon';
import { InvalidPrimaryKeyContainer as Container, InvalidPrimaryKeyContentWrapper as Wrapper, InvalidPrimaryKeyIconContainer as IconContainer, InvalidPrimaryKeyMessage as Message, InvalidPrimaryKeyTitle as Title, } from '../Table.styled';
/** Special information for the component in the documentation goes here. */
var InvalidPrimaryKey = function (_a) {
    var visible = _a.visible, _b = _a.__TYPE, TYPE = _b === void 0 ? 'InvalidPrimaryKey' : _b, other = __rest(_a, ["visible", "__TYPE"]);
    return visible ? (React.createElement(Container, null,
        React.createElement(IconContainer, null,
            React.createElement(Icon, { "aria-label": "Invalid Primary Key", bold: true, name: "exclamation-circle" })),
        React.createElement(Wrapper, null,
            React.createElement(Message, null,
                React.createElement(Title, null, "Invalid Primary Key"),
                React.createElement("p", null,
                    "The Primary Key for this dataset provided to the table below is incorrect and does not exist on the objects in the dataset. Please check the\u00A0",
                    React.createElement("b", null, "primaryKey"),
                    " prop value."))))) : null;
};
InvalidPrimaryKey.defaultProps = {
    __TYPE: 'InvalidPrimaryKey',
};
export default InvalidPrimaryKey;
